// Traduz e explica os erros do fatiador (Bambu Studio ou Anycubic Slicer
// Next, conforme a impressora selecionada) pra quem usa o app.
// O motor responde em inglês e às vezes de forma bem técnica (ex.: "G-code
// conflicts detected..."). Aqui a gente reconhece os casos mais comuns e
// devolve um título + uma linha curta em português; quando não reconhece
// o padrão mas percebe que é uma mensagem em inglês, mostra só um aviso curto
// ("tente mais tarde / fale com o suporte") em vez do texto cru. O texto
// original fica em detalheTecnico, que vai pro console (não aparece na tela).

const PADROES = [
  {
    testa: /g-code conflicts detected|wipe tower/i,
    titulo: "Torre de purga muito perto das peças",
    explicacao: "Afaste a torre de purga das peças no fatiador, salve o 3MF e envie de novo.",
  },
  {
    testa: /outside (the )?(print )?(area|bed)|out of (the )?(print )?bed|off.?the.?bed/i,
    titulo: "Peça fora da mesa",
    explicacao: "Posicione as peças dentro da mesa no fatiador, salve o 3MF e envie de novo.",
  },
  {
    // Projeto de outra impressora com peças maiores que a mesa da selecionada.
    testa: /over the boundary of the heated bed|no object fully inside/i,
    titulo: "Peças não cabem na mesa desta impressora",
    explicacao: "Confira a impressora selecionada ou reposicione as peças no fatiador, salve o 3MF e envie de novo.",
  },
  {
    testa: /collision|collide/i,
    titulo: "Peças encostando umas nas outras",
    explicacao: "Afaste as peças na mesa do fatiador, salve o 3MF e envie de novo.",
  },
  {
    testa: /empty layer|no extrusions/i,
    titulo: "O modelo tem uma camada vazia",
    explicacao: "Confira se o modelo fatia no fatiador da sua impressora e envie de novo.",
  },
  {
    testa: /invalid extruder assignment/i,
    titulo: "Peça usa um extrusor que a impressora não tem",
    explicacao: "Reatribua os filamentos das peças no fatiador, salve o 3MF e envie de novo.",
  },
  // ── Kobra X (Anycubic Slicer Next) — mensagens de slicer-service/anycubicEngine.js ──
  {
    testa: /Kobra X online does not support painted faces or modifiers/i,
    titulo: "Pintura ou modificadores não são aceitos na Kobra X",
    explicacao: "Fatie no Anycubic Slicer Next e importe o G-code pronto.",
  },
  {
    testa: /Kobra X online requires a 3MF in millimeters/i,
    titulo: "O projeto precisa estar em milímetros",
    explicacao: "Exporte o 3MF em milímetros e envie de novo.",
  },
  {
    testa: /Unsupported 3MF version/i,
    titulo: "Arquivo de uma versão mais nova do Bambu Studio",
    explicacao: "Tente novamente mais tarde ou importe a placa já fatiada.",
  },
  {
    testa: /Unsupported Kobra X nozzle/i,
    titulo: "Bico não suportado na Kobra X",
    explicacao: "Use bico de 0,25, 0,4, 0,6 ou 0,8 mm, ou importe o G-code pronto.",
  },
  {
    testa: /Kobra X slicing is validated only for a .*nozzle/i,
    titulo: "A Kobra X só aceita bico de 0,4 mm",
    explicacao: "Ajuste o bico no projeto ou importe o G-code pronto.",
  },
  {
    testa: /Kobra X slicing is validated only for .*layers/i,
    titulo: "A Kobra X só aceita camada de 0,20 mm",
    explicacao: "Ajuste a altura de camada no projeto ou importe o G-code pronto.",
  },
  {
    testa: /Unsupported Kobra X filament/i,
    titulo: "Filamento não suportado na Kobra X",
    explicacao: "Use PLA, PETG, ABS ou ASA, ou importe o G-code pronto.",
  },
  {
    testa: /selected (3mf )?plate (is not available|contains no)/i,
    titulo: "Placa vazia ou inexistente",
    explicacao: "Escolha uma placa que tenha peças.",
  },
  {
    testa: /invalid (3mf )?transform|contains an invalid (mesh|triangle)|mesh is too large|components are too deep|Missing 3MF object|has no printable model/i,
    titulo: "Não foi possível ler o modelo do 3MF",
    explicacao: "Exporte o 3MF de novo pelo fatiador e envie outra vez.",
  },
  {
    // inclui a mensagem em português da própria Calculadora (health sem anycubicKobraX)
    testa: /Anycubic Slicer Next (with the Kobra X profile )?is not installed|Missing Anycubic profile|fatiador Anycubic para Kobra X ainda n[aã]o est[aá] dispon/i,
    titulo: "Fatiamento da Kobra X indisponível no momento",
    explicacao: "Tente novamente mais tarde. Se o erro persistir, entre em contato com o suporte.",
  },
  {
    testa: /timed? ?out|exceeded \d+ minutes/i,
    titulo: "O fatiamento demorou demais",
    explicacao: "Tente fatiar menos placas por vez ou importe o G-code pronto.",
  },
];

// Prefixos em português que o próprio app já adiciona antes da mensagem
// crua do motor — removidos do "detalhe técnico" pra não duplicar contexto.
const PREFIXOS_CONHECIDOS = [
  "O Bambu Studio não conseguiu fatiar este projeto: ",
  "Anycubic Slicer Next could not slice this project: ",
];

// Palavras bem comuns em inglês que dificilmente aparecem nas mensagens
// próprias do app (essas já são escritas em português) — sinal de que o
// texto veio direto do motor de fatiamento sem passar por nenhum dos
// padrões conhecidos acima.
const MARCAS_INGLES = /\b(the|and|please|make sure|if the|we use|during|successfully|detected|failed|unable to|could not|cannot|can not|does not|not|error|invalid|unknown|missing|unsupported)\b/i;

function limparDetalhe(msg) {
  let detalhe = msg;
  for (const prefixo of PREFIXOS_CONHECIDOS) {
    if (detalhe.startsWith(prefixo)) detalhe = detalhe.slice(prefixo.length);
  }
  return detalhe;
}

export function traduzirErroFatiamento(mensagemOriginal) {
  const msg = String(mensagemOriginal || "").trim();
  if (!msg) {
    return { titulo: "Não foi possível fatiar", explicacao: "Tente novamente mais tarde. Se o erro persistir, entre em contato com o suporte.", dica: null, detalheTecnico: null };
  }
  for (const padrao of PADROES) {
    if (padrao.testa.test(msg)) {
      return { titulo: padrao.titulo, explicacao: padrao.explicacao, dica: null, detalheTecnico: limparDetalhe(msg) };
    }
  }
  if (MARCAS_INGLES.test(msg)) {
    return {
      titulo: "Tente novamente mais tarde.",
      explicacao: "Se o erro persistir, entre em contato com o suporte.",
      dica: null,
      detalheTecnico: limparDetalhe(msg),
    };
  }
  return { titulo: "Não foi possível fatiar", explicacao: msg, dica: null, detalheTecnico: null };
}
